import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import DragDropContainer from '../../DragAndDropContainer';
import { updateContestOrder } from '../../../store/contest/actions';

export const ContestContainer = ({ contests, onEdit, onDelete }) => {
    const dispatch = useDispatch(); 

    if (!contests) {
        return <h2>No Benefits & Policies exist.</h2>;
    }

    const [localCategories, setLocalCategories] = useState(contests);
    const [trackOrderCategories, setTrackOrderCategories] = useState(contests);

    useEffect(() => {
        if (contests) {
            setLocalCategories(contests);
        }
    }, [contests]);

    const moveCategory = (fromIndex, toIndex, makeApiCall) => {
        const updatedCategories = [...localCategories];
        const [movedItem] = updatedCategories.splice(fromIndex, 1);
        updatedCategories.splice(toIndex, 0, movedItem);

        const newUpdatedCategories = updatedCategories.map((category, index) => ({
            ...category,
            order: index,
        }));

        setLocalCategories(newUpdatedCategories);
        setTrackOrderCategories(newUpdatedCategories);
        if (makeApiCall) {
            setLocalCategories(trackOrderCategories);

            const ids = trackOrderCategories.map((category) => category.id).join(',');
            dispatch(updateContestOrder(ids));
        }
    };

    const renderCategoryItem = (contest) => (
        <div className={`admin-drag-box ${contest.visibility != 0 ? 'inactiveItem' : ''}`} key={contest.id}>
            <span className="admin-title-name-wrap">
                <span className="admin-drag-box-name">{contest.title}</span>
                {contest && contest?.companyInfo &&
                    <span className="admin-drag-box-companies">
                        {contest.companyInfo}
                    </span>
                }
            </span> 
            <span className="admin-drag-option-wrap">
                {contest.visibility != 0 ? <span className="inactiveStatus">Inactive</span> : null}
                <button
                    className="admin-drag-option edit"
                    onClick={() => onEdit(contest)}
                >
                    <span className="material-symbols-rounded">edit</span>
                </button>
                <button
                    className="admin-drag-option delete"
                    onClick={() => onDelete(contest)}
                >
                    <span className="material-symbols-rounded">delete</span>
                </button>
            </span>
        </div>
    );

    return (
        <DragDropContainer
            items={localCategories}
            moveItem={moveCategory}
            renderItem={renderCategoryItem}
            isHorizontal={false}
        />
    );
};
ContestContainer.propTypes = {
    contests: PropTypes.array.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
};
